import { render, staticRenderFns } from "./ItemMoveEverything.vue?vue&type=template&id=327dd055"
import script from "./ItemMoveEverything.vue?vue&type=script&lang=js"
export * from "./ItemMoveEverything.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports